import { useCommunityFeedActionMutation } from './useCommunityFeedActionMutation';

const BAN_MEMBER_ACTION = '/ban_community_member';

interface BanMemberVars {
  memberId: string;
  reason?: string;
}

export const useBanMemberMutation = () =>
  useCommunityFeedActionMutation<BanMemberVars>({
    buildRequest: ({ memberId, reason }) => ({
      path: BAN_MEMBER_ACTION,
      fields: { member_id: memberId, ...(reason ? { reason } : {}) },
    }),
  });
